import { CreateNewCard } from "./CreateNewCard";

export default CreateNewCard;